import { Helmet } from "react-helmet-async";
import HeroCampaign from "@/components/home/HeroCampaign";
import ValueStrip from "@/components/home/ValueStrip";
import ManifestoStrip from "@/components/home/ManifestoStrip";
import ZemelapisStrip from "@/components/home/ZemelapisStrip";
import NewsletterToliau from "@/components/home/NewsletterToliau";

const Pagrindinis = () => (
  <div className="relative bg-cream">
    <Helmet>
      <title>Diet of Happiness | The Archetype Test and the Maps</title>
      <meta
        name="description"
        content="Diet of Happiness — the free Archetype Test, the SOLO Map about you and the Couples Map for the two of you. Documents written in your own words."
      />
      <meta property="og:title" content="Diet of Happiness" />
      <meta property="og:description" content="The free Archetype Test, the SOLO Map and the Couples Map. Finally, a diet worth sticking to." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://dietofhappiness.com/" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="canonical" href="https://dietofhappiness.com/" />
    </Helmet>

    <HeroCampaign />
    <ValueStrip />
    <ZemelapisStrip />
    <ManifestoStrip />
    <NewsletterToliau />
  </div>
);

export default Pagrindinis;
